export default {
  "header-login": () => import("/www/gamefi/layouts/Header/Login.vue").then(m => m.default || m),
  "header-wallet": () => import("/www/gamefi/layouts/Header/Wallet.vue").then(m => m.default || m),
  header: () => import("/www/gamefi/layouts/Header/index.vue").then(m => m.default || m),
  casino: () => import("/www/gamefi/layouts/casino.vue").then(m => m.default || m),
  default: () => import("/www/gamefi/layouts/default.vue").then(m => m.default || m),
  "game-coat": () => import("/www/gamefi/layouts/gameCoat/index.vue").then(m => m.default || m),
  "game-coat-roulette": () => import("/www/gamefi/layouts/gameCoat/roulette.vue").then(m => m.default || m),
  "game-coat-ts-game-coat": () => import("/www/gamefi/layouts/gameCoat/ts/gameCoat.ts").then(m => m.default || m)
}